export const Black = 'black';

export const FontColorPrimary = '#212529';
export const FontColorSecondary = '#9e9e9e';

export const fade = (color: string, opacity: number): string => {
    return color.replace('rgb', 'rgba').replace(')', `, ${opacity / 100})`);
}

export default class AgTechColors {
    static White: string = 'rgb(255, 255, 255)';
    static Primary: string = 'rgb(20, 20, 20)';
    static Secondary: string = 'rgb(30, 43, 55)';//'rgb(40, 53, 67)';
    static Tertiary: string = 'rgb(55, 65, 82)';
    static HighlightLight: string = 'rgba(100, 204, 255, .2)';
    static Highlight: string = 'rgb(50, 120, 245)';
    static HighlightDark: string = 'rgb(35, 70, 140)';//'rgb(0, 37, 80)';//'#142F43';//'rgb(6, 40, 61)';//'rgb(24, 70, 168)';
    static Background: string = 'rgb(231, 234, 239)';
    static BorderColor: string = 'rgb(210, 210, 210)';
    static Shadow: string = 'rgb(230, 230, 230)';

    static DarkGreen: string = 'rgb(0,153,76)';
    static SolidGreen: string = 'rgb(0, 200, 120)';
    static Green: string = 'rgb(17,221,17)';

    static Red = 'rgb(250, 20, 20)';
    static SolidRed = 'rgb(250, 125, 125)';
    static DarkRed = 'rgb(200, 10, 10)';

    static Yellow = 'rgb(240, 230, 20)';
    static DarkYellow = 'rgb(200, 200, 0)';

    static Cyan = 'rgb(0, 161, 255)';
    static DarkCyan = 'rgb(0, 100, 200)';

    static Orange = 'rgb(255, 200, 0)';
    static SolidOrange = 'rgb(255, 200, 0)';

    static GreenAccent = (opacity: number) => fade(AgTechColors.Green, opacity);
    static RedAccent = (opacity: number) => fade(AgTechColors.Red, opacity);
    static YellowAccent = (opacity: number) => fade(AgTechColors.Yellow, opacity);
    static HighlightAccent = (opacity: number) => fade(AgTechColors.Highlight, opacity);
    static HighlightDarkAccent = (opacity: number) => fade(AgTechColors.HighlightDark, opacity);
    static GrayAccent = (opacity: number) => fade(AgTechColors.Background, opacity);
    static CyanAccent = (opacity: number) => fade(AgTechColors.Cyan, opacity);
    static PrimaryAccent = (opacity: number) => fade(AgTechColors.Primary, opacity);

    // Font
    static FontColorPrimary: string = '#212529';
    static FontColorSecondary: string = 'rgb(163, 163, 163)';
    static FontColorTertiary: string = '#858585';

    // Grays
    static GrayLightest = '#D3E0EA';

    // Future
    static PrimaryDark = '#20262e';
    static PrimaryLighter = '#282f39';

    // Blue
    static DarkBlue = 'rgb(41, 58, 83)';
    static PrimaryBlue = 'rgb(31, 63, 113)';
    static HighlightBlue = 'rgb(50, 120, 245)';

    static Combinations = {  
        Highlight: {
            backgroundColor: AgTechColors.HighlightAccent(10),
            borderColor: AgTechColors.HighlightDark,
            fontColor: AgTechColors.HighlightDark,
            stripeColor: AgTechColors.HighlightAccent(25)
        },
        Gray: {
            backgroundColor: AgTechColors.GrayAccent(40),
            borderColor: AgTechColors.BorderColor,
            fontColor: AgTechColors.FontColorSecondary,
            stripeColor: AgTechColors.GrayLightest
        },
        Green: {
            backgroundColor: AgTechColors.GreenAccent(5),
            borderColor: AgTechColors.SolidGreen,
            fontColor: AgTechColors.DarkGreen,
            stripeColor: AgTechColors.GreenAccent(50)
        },
        Yellow: {
            backgroundColor: AgTechColors.YellowAccent(20),
            borderColor: AgTechColors.DarkYellow,
            fontColor: AgTechColors.DarkYellow,
            stripeColor: AgTechColors.YellowAccent(80)
        },
        Orange: {
            backgroundColor: fade(AgTechColors.Orange, 10),
            borderColor: AgTechColors.SolidOrange,
            fontColor: AgTechColors.Primary,
            stripeColor: AgTechColors.Orange
        },
        Red: {
            backgroundColor: AgTechColors.RedAccent(5),
            borderColor: AgTechColors.SolidRed,
            fontColor: AgTechColors.DarkRed,
            stripeColor: AgTechColors.SolidRed
        }
    }

    static fadeColor = (color: string, opacity: number): string => {
        return fade(color, opacity);
    }
}

export type AgTechColorCombination = {
    backgroundColor: string,
    borderColor: string,
    fontColor: string,
    stripeColor: string
}

